import { useCallback } from 'react';
import { View } from 'foundations-components/components/View';
import { Popover, PopoverBody, PopoverHeader } from 'foundations-components/transitional/components/Popover';
import { Text } from 'foundations-components/components/Text';
import { styled } from '../../lib/styles';

// A little cheeky but it's much more efficient than cloning the events to put a wrapper element around them
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const GridGap = styled.div.withConfig({
  displayName: "OverflowPopover__GridGap",
  componentId: "f1hrji-0"
})(["display:grid;row-gap:8px;"]);
export const OverflowPopover = ({
  open,
  onClose,
  title,
  overflowEvents,
  children
}) => {
  const handleOpenChange = useCallback(e => {
    if (e.target.value === false) {
      onClose();
    }
  }, [onClose]);
  return /*#__PURE__*/_jsx(Popover, {
    "data-test-id": "overflow-popover",
    open: open,
    onOpenChange: handleOpenChange,
    inlineSize: "250px",
    content: /*#__PURE__*/_jsxs(View, {
      paddingInline: "400",
      paddingBlock: "300",
      children: [/*#__PURE__*/_jsx(PopoverHeader, {
        showCloseButton: true,
        onOpenChange: handleOpenChange,
        paddingInline: "0",
        paddingBlock: "0",
        children: /*#__PURE__*/_jsx(Text, {
          typography: "body-100",
          paddingBlockEnd: "200",
          children: title
        })
      }), /*#__PURE__*/_jsx(PopoverBody, {
        paddingInline: "0",
        paddingBlock: "0",
        children: /*#__PURE__*/_jsx(View, {
          overflowY: "scroll",
          maxBlockSize: "80vh",
          children: /*#__PURE__*/_jsx(GridGap, {
            "data-test-id": "overflow-popover-events",
            children: overflowEvents
          })
        })
      })]
    }),
    children: children
  });
};